<div class="car-plate-field">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-6 mb-3 mb-lg-0">
      <div class="input-group">
        <label for="carPlateNumber">
          {{ 'VEHICLE_FLOW.PLATE_LICENSE_NUMBER' | translate }}
          @if (props.required) {
          <span class="required">*</span>
          }
        </label>
        <p-inputNumber inputId="carPlateNumber" mode="decimal" [useGrouping]="false" [formControl]="numberControl"
          [maxlength]="countrySettings()?.maxDigits" [min]="countrySettings()?.minDigits"
          [class.p-invalid]="hasInvalidCharacters()" [disabled]="props.disabled ?? false" />
        @if (props.required && !getNumbersValue() && (numberControl.touched || numberControl.dirty)) {
        <small class="p-error">{{ 'VEHICLE_FLOW.PLATE_LICENSE_NUMBER_REQUIRED' | translate }}</small>
        }
        @if (hasInvalidCharacters()) {
        <small class="p-error">{{ errorMessageNumbers() }}</small>
        }
      </div>
    </div>

    <div class="col-12 col-lg-6 mb-3 mb-lg-0">
      <div class="input-group letters">
        <label for="carPlateLetters">
          {{ 'VEHICLE_FLOW.PLATE_LICENSE_LETTERS' | translate }}
          @if (props.required) {
          <span class="required">*</span>
          }
        </label>
        <input type="text" id="carPlateLetters" pInputText [formControl]="lettersControl" dir="auto"
          [maxlength]="getLettersInputMaxLength()" [minlength]="getLettersInputMinLength()"
          [class.p-invalid]="hasInvalidLetters()" [disabled]="props.disabled ?? false"
          placeholder="{{ 'VEHICLE_FLOW.ENTER_LETTERS' | translate }}" (input)="onLettersInput($event)"
          [ngClass]="{'plate-ar': isArabicLetter(getLettersValue())}" />
        @if (props.required && !getLettersValue() && (lettersControl.touched || lettersControl.dirty)) {
        <small class="p-error">{{ 'VEHICLE_FLOW.PLATE_LICENSE_LETTERS_REQUIRED' | translate }}</small>
        }
        @if (hasInvalidLetters()) {
        <small class="p-error">{{ errorMessageLetters() }}</small>
        }
        @if (getAllowedLetters().length > 0 && !props.disabled) {
        <div class="d-flex align-items-center mt-1 gap-1">
          <small class="text-muted">{{ 'VEHICLE_FLOW.ALLOWED_LETTERS' | translate }}</small>
          <i class="pi pi-info-circle text-info cursor-pointer" pTooltip="{{ getAllowedLettersTooltip() }}"
            tooltipPosition="right"></i>
        </div>
        }
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <!-- Loading State -->
      @if (isLoading()) {
      <p-skeleton class="mt-0 mt-lg-3 loading-container" height="150px" width="100%" />
      }

      <!-- Mapping Box -->
      @if (!isLoading()) {
      <div class="car-plate-preview">
        <div class="plate-box">
          <div class="row g-0">
            <div class="col-9">
              <div class="plate-row h-100">
                <div class="row h-100 g-0">
                  <div class="col-6">
                    <div class="plate-numbers">
                      {{ originalNumbers() }}
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="plate-letters"
                      [ngClass]="{'plate-ar': isArabicLetter(originalLetters()[0]), 'plate-letters-rtl': isArabicLetter(originalLetters()[0])}">
                      @if (getLettersValue()) {
                      @for (l of originalLetters(); track $index) {
                      <span [attr.dir]="isArabicLetter(l) ? 'rtl' : 'ltr'">{{ l }} </span>
                      }
                      }
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="plate-numbers plate-ar border-bottom-0">
                      {{ mappedNumbers() }}
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="plate-letters plate-letters-mapped border-bottom-0"
                      [ngClass]="{'plate-ar': isArabicLetter(mappedLetters()[0]), 'plate-letters-mapped-reversed': isArabicLetter(originalLetters()[0])}">
                      @if (getLettersValue()) {
                      @for (l of mappedLetters(); track $index) {
                      <span [attr.dir]="isArabicLetter(l) ? 'rtl' : 'ltr'">{{ l }} </span>
                      }
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="plate-country-logo text-center">
                <img [src]="countrySettings()?.logo" [alt]="countrySettings()?.text + ' Logo'" height="32" />
              </div>
              <div class="plate-country-text text-center">
                <div>
                  @for (char of countrySettings()?.text?.split('') || []; track $index) {
                  <span>{{ char }}</span>
                  @if ($index
                  < (countrySettings()?.text?.length || 0) - 1) { <br />
                  }
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
